export const snackbar = ({ ui }) => ui.snackbar;
